import isEmpty from 'lodash/isEmpty';
import APIService from '../APIService';
import { API_HOST, apiEndpoints } from '../../constants/APIConstants';
import AppService from '../AppService';

export default {
  authLogin(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      if (isEmpty(`${options.phoneNumber}`)) reject(new Error('Invalid Params'));
      else {
        APIService.request(
          {
            method: 'POST',
            data: options,
            url: `${API_HOST}${apiEndpoints.AUTH_LOGIN}`,
            isAuthenticated: false,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
      }
    });
  },
  authOTP(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      if (isEmpty(`${options.otp}`)) reject(new Error('Invalid Params'));
      else {
        APIService.request(
          {
            method: 'POST',
            data: options,
            isAuthenticated: false,
            url: `${API_HOST}${apiEndpoints.AUTH_OTP}`,
            additionalHeaders: { 'Utm-Source': AppService.getUTMSource() },
            includeTrackingProperties: true,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
      }
    });
  },
  fbLogin(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      if (isEmpty(`${options.accessToken}`)) reject(new Error('Invalid Params'));
      else {
        APIService.request(
          {
            method: 'GET',
            isAuthenticated: false,
            url: `${API_HOST}${apiEndpoints.FB_LOGIN}?access_token=${options.accessToken}`,
            additionalHeaders: { 'Utm-Source': AppService.getUTMSource() },
            includeTrackingProperties: true,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
      }
    });
  },
  fbUserUpdatePhoneNumber(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      if (isEmpty(`${options.otp}`)) reject(new Error('Invalid Params'));
      else {
        APIService.request(
          {
            method: 'POST',
            data: options,
            isAuthenticated: true,
            url: `${API_HOST}${apiEndpoints.FB_UPDATE_PHONE_NUMBER}`,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
      }
    });
  },
  deleteUser(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      if (isEmpty(`${options.otp}`)) reject(new Error('Invalid Params'));
      else {
        APIService.request(
          {
            method: 'DELETE',
            data: options,
            isAuthenticated: true,
            url: `${API_HOST}${apiEndpoints.DELETE_USER}`,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
      }
    });
  },
};
